import { Injectable } from '@angular/core';
import { IDescriptionObject } from "../../hotel/models/details";
import { IBookingPropertyDescription } from "../resources/booking/interfaces/IGetBookings";
import { HostAliasPipe } from "libraries/pipes/host-alias/host-alias.pipe";
import { Observable } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { EHosts } from "libraries/enums/EHosts";

export type TDescription = IDescriptionObject | IBookingPropertyDescription;

@Injectable()
export class DescriptionHelperService {

    constructor(
        private readonly hostAliasPipe: HostAliasPipe,
        private readonly asyncPipe: AsyncPipe,
    ) {
    }

    public replaceHostWithAlias(initialDescription: TDescription[]): TDescription[] {

        return initialDescription.map((description: TDescription): TDescription => {
            return {
                ...description,
                textLines: description.textLines.map((textLine: string): string => {
                    const hostArray: string[] = Object.values(EHosts);
                    const hostArrayUpperFirst: string[] = hostArray.map(
                        (host:string): string => {
                            return host.charAt(0).toUpperCase() + host.slice(1).toLowerCase();
                        }
                    );
                    const allHostArray: string[] = [
                        ...hostArray,
                        ...hostArrayUpperFirst,
                    ];

                    let outPut: string = textLine;

                    allHostArray.forEach(
                        (host: string): void => {
                            const alias: Observable<string> = this.hostAliasPipe.transform(host);
                            const aliasString: string = this.asyncPipe.transform(alias);
                            outPut = textLine.replace(host,aliasString);
                        }
                    );
                    return outPut;
                })
            };
        });
    }
}